import { render, staticRenderFns } from "./MapaCalor.vue?vue&type=template&id=98a994a4&"
import script from "./MapaCalor.vue?vue&type=script&lang=js&"
export * from "./MapaCalor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports